var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 34,
    viewBox: "0 0 56 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11498_45434)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M35.5549 3.66275H20.4003V30.5821H35.5549V3.66275Z",
    fill: "#FF5A00"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M21.4091 17.1224C21.4091 11.6532 24.0096 6.7991 28 3.66276C25.0633 1.37977 21.3587 0 17.3179 0C7.7454 0 0 7.65799 0 17.1224C0 26.5869 7.7454 34.2448 17.3179 34.2448C21.3587 34.2448 25.0633 32.8651 28 30.5821C24.004 27.4901 21.4091 22.5916 21.4091 17.1224Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M56 17.1224C56 26.5869 48.2546 34.2448 38.6821 34.2448C34.6413 34.2448 30.9367 32.8651 28 30.5821C32.0408 27.4402 34.5909 22.5916 34.5909 17.1224C34.5909 11.6532 31.9904 6.7991 28 3.66276C30.9311 1.37977 34.6357 0 38.6765 0C48.2546 0 56 7.70786 56 17.1224Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11498_45434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6aa9d7fb21d4a5c0e590f78cdd00ca2a.svg";
export { ForwardRef as ReactComponent };